module.exports = __webpack_public_path__ + "static/media/top-image.65b213e4.png";